"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Compiler = void 0;
const helpers_1 = require("./helpers");
class Compiler {
    constructor() {
        this._sources = {};
        // This completely blocks the thread. Useful for testing heavy work on
        // the worker thread (if you run it on the main thread, you'll freeze the app)
        this.block = (seconds) => {
            const start = new Date().valueOf();
            while (new Date().valueOf() - seconds * 1000 < start) {
                // blockeroo
            }
        };
    }
    updateSource(source) {
        this._sources[source.scriptId] = source;
    }
    removeSource(scriptId) {
        delete this._sources[scriptId];
    }
    get compilableSources() {
        const mainLines = Object.keys(this._sources).map((id) => `INCLUDE ${id}`);
        const main = (0, helpers_1.linesToTextFile)(mainLines);
        const includes = {};
        Object.values(this._sources).forEach(({ scriptId, blockLines }) => {
            includes[scriptId] = (0, helpers_1.blockLinesToInkFile)(blockLines);
        });
        return { main, includes };
    }
    compile() {
        return __awaiter(this, void 0, void 0, function* () {
            const { compilerMessages, inkJson } = yield (0, helpers_1.compileInk)(this.compilableSources);
            // build compiler messages out of any load errors and
            // compiler messages
            const messages = [];
            Object.values(this._sources).forEach(({ loadError, scriptId }) => {
                if (loadError) {
                    messages.push({
                        message: loadError,
                        file: scriptId,
                        type: 'error',
                    });
                }
            });
            compilerMessages.forEach((rawMessage) => {
                messages.push(this.enrichCompilerMessage(rawMessage));
            });
            return {
                inkJson,
                messages,
            };
        });
    }
    enrichCompilerMessage(rawMessage) {
        const enrichedMessage = (0, helpers_1.parseCompileMessage)(rawMessage);
        const { file, lineNumber } = enrichedMessage;
        if (file && typeof lineNumber === 'number') {
            const source = this._sources[file];
            const blockLine = source === null || source === void 0 ? void 0 : source.blockLines.find((line) => line.lineNumber === lineNumber);
            enrichedMessage.blockId = blockLine === null || blockLine === void 0 ? void 0 : blockLine.id;
        }
        return enrichedMessage;
    }
}
exports.Compiler = Compiler;
